/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_User_Lockout_Not_EnabledInputs */

const nl_auth_password_errors_user_lockout_not_enabled = /** @type {(inputs: Auth_Password_Errors_User_Lockout_Not_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accountvergrendeling is niet ingeschakeld`)
};

/**

* @param {Auth_Password_Errors_User_Lockout_Not_EnabledInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_user_lockout_not_enabled = /** @type {((inputs?: Auth_Password_Errors_User_Lockout_Not_EnabledInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_User_Lockout_Not_EnabledInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_user_lockout_not_enabled(inputs)
});
export { auth_password_errors_user_lockout_not_enabled as "auth.password_errors.user_lockout_not_enabled" }